import { createSelector } from 'reselect';
import type { State } from '../types.tsx';

export const getCollectionsFlow = (state: State) => state.collections;

export const getCollectionsTourDismissed = createSelector(
	getCollectionsFlow,
	(collections) => collections.tourDismissed,
);

export const getTourSpotlightStep = createSelector(
	getCollectionsFlow,
	(collections) => collections.tourSpotlightStep,
);

export const getCollectionsIntroductionDismissed = createSelector(
	getCollectionsFlow,
	(collections) => collections.introductionDismissed,
);

export const getCollectionsIntroductionPrerequisiteDismissalsMet = createSelector(
	getCollectionsFlow,
	(collections) => collections.introductionPrerequisiteDismissalsMet,
);
